import React from "react";
// import { Carousel } from "@arco-design/web-react";
// import locale from "./locale";
import bannerimg from "@/assets/iconimage/bannerimg.png";
import star from "@/assets/iconimage/star.png";
import textfoolt from "@/assets/iconimage/textfoolt.png";
import textfoolt2 from "@/assets/iconimage/textfoolt2.png";
import "./style/style.less";
import "./style/banner.less";
import { observer } from "mobx-react";
import appStore from "@/stores/appStore";
const LoginBanner = () => {
  // const data = [
  //   {
  //     slogan: "login.banner.slogan1",
  //     subSlogan: "login.banner.subSlogan1",
  //     image:
  //       "http://p1-arco.byteimg.com/tos-cn-i-uwbnlip3yd/6c85f43aed61e320ebec194e6a78d6d3.png~tplv-uwbnlip3yd-png.png",
  //   },
  //   {
  //     slogan: "login.banner.slogan2",
  //     subSlogan: "login.banner.subSlogan2",
  //     image:
  //       "http://p1-arco.byteimg.com/tos-cn-i-uwbnlip3yd/6c85f43aed61e320ebec194e6a78d6d3.png~tplv-uwbnlip3yd-png.png",
  //   },
  //   {
  //     slogan: "login.banner.slogan3",
  //     subSlogan: "login.banner.subSlogan3",
  //     image:
  //       "http://p1-arco.byteimg.com/tos-cn-i-uwbnlip3yd/6c85f43aed61e320ebec194e6a78d6d3.png~tplv-uwbnlip3yd-png.png",
  //   },
  // ];
  return (
    // <Carousel className="carousel" animation="fade">
    //   {data.map((item, index) => (
    //     <div key={`${index}`}>
    //       <div className="item">
    //         <div className="title">{item.slogan}</div>
    //         <div className="sub-title">{item.subSlogan}</div>
    //         <img alt="banner-image" className="image" src={item.image} />
    //       </div>
    //     </div>
    //   ))}
    // </Carousel>
    <div className="carousel" style={{
      background: !appStore.isOdm
        ? "linear-gradient(158deg, #3482ff, #ab50ff)"
        : "linear-gradient( 135deg, #FFFFFF 0%, #F6EFFF 0%, #B8CFFF 53%, #C3F7FF 100%)",
    }}>
      <div
        className="item"
      >
        {!!appStore.config?.web?.login?.background_image && (
          <div className="item_img_contel">
            <img
              alt="banner-image"
              className="animate__animated animate__zoomIn"
              style={{ width: '85%' }}
              src={appStore.config?.web?.login?.background_image}
            />
            <img className="star_image" src={star} width={50} />
            <img
              className="textfoolt  banner_textfoolt_image"
              src={!appStore.isOdm ? textfoolt : textfoolt2}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default observer(LoginBanner);
